module.exports = __webpack_public_path__ + "assets/google-sheets-icon.d329eb46.svg";